import { useState } from 'react';
import { useAppSelector } from '../redux/store';

export const currencyTypes = {
	gbp: '£',
	eur: '€',
	usd: '$',
	aed: 'AED'
} as const;

type ValidCurrency = keyof typeof currencyTypes;

export const useCurrency = () => {
	const user = useAppSelector((state) => state.user.currentUser);
	const [currencyCode, setCurrency] = useState<ValidCurrency>((): ValidCurrency => {
		// Detect user's regional currency
		const detectedCurrency = user?.currency ?? 'usd';

		// Store the detected currency if not already stored
		if (!localStorage.getItem('detected_currency')) {
			localStorage.setItem('detected_currency', detectedCurrency);
		}

		return detectedCurrency as ValidCurrency;
	});

	const updateCurrency = (newCurrency: string) => {
		const detectedCurrency = localStorage.getItem('detected_currency');
		if (detectedCurrency !== newCurrency && newCurrency in currencyTypes) {
			setCurrency(newCurrency as ValidCurrency);
			localStorage.setItem('detected_currency', newCurrency);
		}
	};

	const currencySymbol = currencyTypes[currencyCode];

	return {
		currencyCode,
		currencySymbol,
		setCurrency: updateCurrency
	};
};
